import { Routes, Route } from 'react-router-dom';
import * as path from './RoutesNames';
import Login from '../pages/Login/Login';
import Dashboard from '../pages/Dashboard/Dashboard';
import Cliente from '../pages/Dashboard/Cliente/Pesquisar/ClientePesquisar';
import Home from '../pages/Dashboard/Home/Home';
import Usuario from '../pages/Dashboard/Usuario/Pesquisar/UsuarioPesquisar';
import Produto from '../pages/Dashboard/Produto/Pesquisar/ProdutoPesquisar';
import ProdutoCadastrar from '../pages/Dashboard/Produto/Cadastrar/ProdutoCadastrar';
import PrestacaoDeContas from '../pages/Dashboard/PrestacaoConta/Pesquisar/PrestacaoContasPesquisar';
import ClienteCadastrar from '../pages/Dashboard/Cliente/Cadastrar/ClienteCadastrar';
import Banco from '../pages/Dashboard/Banco/Pesquisar/BancoPesquisar';
import BancoCadastrar from '../pages/Dashboard/Banco/Cadastrar/BancoCadastrar';
import UsuarioCadastrar from '../pages/Dashboard/Usuario/Cadastrar/UsuarioCadastrar';
import TrocarSenha from '../pages/Dashboard/Usuario/TrocarSenha/TrocarSenha';
import PapelPesquisar from '../pages/Dashboard/Papel/Pesquisar/PapelPesquisar';
import PapelCadastrarTela from '../pages/Dashboard/Papel/Cadastrar/PapelCadastrar';
import CondicaoPagamento from '../pages/Dashboard/CondicaoPagamento/Pesquisar/CondicaoPagamentoPesquisar';
import CondicaoPagamentoCadastrar from '../pages/Dashboard/CondicaoPagamento/Cadastrar/CondicaoPagamentoCadastrar';
import TipoPagamento from '../pages/Dashboard/TipoPagamento/Pesquisar/TipoPagamentoPesquisar';
import TipoPagamentoCadastrar from '../pages/Dashboard/TipoPagamento/Cadastrar/TipoPagamentoCadastrar';
import CategoriaFinanceira from '../pages/Dashboard/CategoriaFinanceira/Pesquisar/CategoriaFinanceiraPesquisar';
import CategoriaFinanceiraCadastrar from '../pages/Dashboard/CategoriaFinanceira/Cadastrar/CategoriaFinanceiraCadastrar';
import ContaBancaria from '../pages/Dashboard/ContaBancaria/Pesquisar/ContaBancariaPesquisar';
import ContaBancariaCadastrar from '../pages/Dashboard/ContaBancaria/Cadastrar/ContaBancariaCadastrar';
import CentroCusto from '../pages/Dashboard/CentroCusto/Pesquisar/CentroCustoPesquisar';
import CentroCustoCadastrar from '../pages/Dashboard/CentroCusto/Cadastrar/CentroCustoCadastrar';
import GrupoProduto from '../pages/Dashboard/GrupoProduto/Pesquisar/GrupoProdutoPesquisar';
import GrupoProdutoCadastrar from '../pages/Dashboard/GrupoProduto/Cadastrar/GrupoProdutoCadastrar';
import Fornecedor from '../pages/Dashboard/Fornecedor/Pesquisar/FornecedorPesquisar';
import FornecedorCadastrar from '../pages/Dashboard/Fornecedor/Cadastrar/FornecedorCadastrar';
import Marca from '../pages/Dashboard/Marca/Pesquisar/MarcaPesquisar';
import MarcaCadastrar from '../pages/Dashboard/Marca/Cadastrar/MarcaCadastrar';
import Fabricante from '../pages/Dashboard/Fabricante/Pesquisar/FabricantePesquisar';
import FabricanteCadastrar from '../pages/Dashboard/Fabricante/Cadastrar/FabricanteCadastrar';
import Modelo from '../pages/Dashboard/Modelo/Pesquisar/ModeloPesquisar';
import ModeloCadastrar from '../pages/Dashboard/Modelo/Cadastrar/ModeloCadastrar';
import UnidadeMedida from '../pages/Dashboard/UnidadeMedida/Pesquisar/UnidadeMedidaPesquisar';
import UnidadeMedidaCadastrar from '../pages/Dashboard/UnidadeMedida/Cadastrar/UnidadeMedidaCadastrar';
import FormaPagamento from '../pages/Dashboard/FormaPagamento/Pesquisar/FormaPagamentoPesquisar';
import FormaPagamentoCadastrar from '../pages/Dashboard/FormaPagamento/Cadastrar/FormaPagamentoCadastrar';
import AdicionarProduto from '../pages/Dashboard/Pedido/AdicionarProduto/AdicionarProdutoCadastrar';
import DevolucaoFornecedor from '../pages/Dashboard/DevolucaoFornecedor/Pesquisar/DevolucaoFornecedorPesquisar';
import ImportacaoXML from '../pages/Dashboard/ImportacaoXML/Pesquisar/ImportacaoXMLPesquisar';
import ImportacaoXMLCadastrar from '../pages/Dashboard/ImportacaoXML/Cadastrar/ImportacaoXMLCadastrar';
import ContasReceber from '../pages/Dashboard/ContasReceber/Pesquisar/ContasReceberPesquisar';
import ContasReceberLancamento from '../pages/Dashboard/ContasReceber/Lancamento/ContasReceberLancamento'
import GrupoCliente from '../pages/Dashboard/GrupoCliente/Pesquisar/GrupoClientePesquisar';
import GrupoClienteCadastrar from '../pages/Dashboard/GrupoCliente/Cadastrar/GrupoClienteCadastrar';
import RequireAuth from '../context/login/RequireAuth';
import OrdemServico from '../pages/Dashboard/OrdemServico/Pesquisar/OrdemServicoPesquisar';
import OrdemServicoCadastrar from '../pages/Dashboard/OrdemServico/Cadastrar/OrdemServicoCadastrar';
import { PedidoDetalhes } from '../pages/Dashboard/Pedido/Detalhes/PedidoDetalhes';
import { PedidoPesquisar } from '../pages/Dashboard/Pedido/Pesquisar/PedidoPesquisar';
import ContasPagar from '../pages/Dashboard/ContasPagar/Pesquisar/ContasPagarPesquisar';
import ContasPagarCadastrar from '../pages/Dashboard/ContasPagar/Cadastrar/ContasPagarCadastrar';
import Cfop from '../pages/Dashboard/CFOP/Pesquisar/CfopPesquisar';
import CfopCadastrar from '../pages/Dashboard/CFOP/Cadastrar/CfopCadastrar';
import Maquina from '../pages/Dashboard/Maquina/Pesquisar/MaquinaPesquisar';
import MaquinaCadastrar from '../pages/Dashboard/Maquina/Cadastrar/MaquinaCadastrar';
import MaquinaConsultar from '../pages/Dashboard/Maquina/Consultar/MaquinaConsultar';
import CaixaLancamento from '../pages/Dashboard/CaixaLancamento/Pesquisar/CaixaLancamentoPesquisar';
import NotaFiscal from '../pages/Dashboard/NotaFiscal/Pesquisar/NotaFiscalPesquisar';
import Boleto from '../pages/Dashboard/Boleto/Pesquisar/BoletoPesquisar';
import MovimentacaoEstoque from '../pages/Dashboard/MovimentacaoEstoque/Pesquisar/MovimentacaoEstoquePesquisar';
import ReajusteEstoque from '../pages/Dashboard/ReajusteEstoque/Pesquisar/ReajusteEstoquePesquisar';
import ReajusteEstoqueCadastrar from '../pages/Dashboard/ReajusteEstoque/Cadastrar/ReajusteEstoqueCadastrar';
import ContasReceberCadastrar from '../pages/Dashboard/ContasReceber/Cadastrar/ContasReceberCadastrar';

const AppRoutes = () => {
  return (
    <Routes>
      <Route path='/' element={<Login />} />
      <Route
        path={path.Dashboard}
        element={
          <RequireAuth>
            <Dashboard />
          </RequireAuth>
        }
      >
        <Route path={path.Home} element={<Home />} />

        <Route path={path.Cliente} element={<Cliente />} />
        <Route path={path.ClienteAtualizar} element={<ClienteCadastrar />} />
        <Route path={path.ClienteCadastrar} element={<ClienteCadastrar />} />

        <Route path={path.Usuario} element={<Usuario />} />
        <Route path={path.UsuarioAtualizar} element={<UsuarioCadastrar />} />
        <Route path={path.UsuarioCadastrar} element={<UsuarioCadastrar />} />
        <Route path={path.TrocarSenha} element={<TrocarSenha />} />
        <Route path={path.Papel} element={<PapelPesquisar />} />
        <Route path={path.PapelCadastrar} element={<PapelCadastrarTela />} />
        <Route path={path.PapelAtualizar} element={<PapelCadastrarTela />} />

        <Route path={path.Banco} element={<Banco />} />
        <Route path={path.BancoCadastrar} element={<BancoCadastrar />} />
        <Route path={path.BancoAtualizar} element={<BancoCadastrar />} />

        <Route path={path.CondicaoPagamento} element={<CondicaoPagamento />} />
        <Route path={path.CondicaoPagamentoCadastrar} element={<CondicaoPagamentoCadastrar />} />
        <Route path={path.CondicaoPagamentoAtualizar} element={<CondicaoPagamentoCadastrar />} />

        <Route path={path.Produto} element={<Produto />} />
        <Route path={path.ProdutoCadastrar} element={<ProdutoCadastrar />} />
        <Route path={path.ProdutoAtualizar} element={<ProdutoCadastrar />} />

        <Route path={path.PrestacaoDeContas} element={<PrestacaoDeContas />} />
        <Route path={path.TipoPagamento} element={<TipoPagamento />} />
        <Route path={path.TipoPagamentoCadastrar} element={<TipoPagamentoCadastrar />} />
        <Route path={path.TipoPagamentoAtualizar} element={<TipoPagamentoCadastrar />} />

        <Route path={path.CategoriaFinanceira} element={<CategoriaFinanceira />} />
        <Route path={path.CategoriaFinanceiraCadastrar} element={<CategoriaFinanceiraCadastrar />} />
        <Route path={path.CategoriaFinanceiraAtualizar} element={<CategoriaFinanceiraCadastrar />} />

        <Route path={path.ContaBancaria} element={<ContaBancaria />} />
        <Route path={path.ContaBancariaCadastrar} element={<ContaBancariaCadastrar />} />
        <Route path={path.ContaBancariaAtualizar} element={<ContaBancariaCadastrar />} />

        <Route path={path.CentroCusto} element={<CentroCusto />} />
        <Route path={path.CentroCustoCadastrar} element={<CentroCustoCadastrar />} />
        <Route path={path.CentroCustoAtualizar} element={<CentroCustoCadastrar />} />

        <Route path={path.GrupoProduto} element={<GrupoProduto />} />
        <Route path={path.GrupoProdutoCadastrar} element={<GrupoProdutoCadastrar />} />
        <Route path={path.GrupoProdutoAtualizar} element={<GrupoProdutoCadastrar />} />

        <Route path={path.Fornecedor} element={<Fornecedor />} />
        <Route path={path.FornecedorCadastrar} element={<FornecedorCadastrar />} />
        <Route path={path.FornecedorAtualizar} element={<FornecedorCadastrar />} />

        <Route path={path.Marca} element={<Marca />} />
        <Route path={path.MarcaCadastrar} element={<MarcaCadastrar />} />
        <Route path={path.MarcaAtualizar} element={<MarcaCadastrar />} />

        <Route path={path.Fabricante} element={<Fabricante />} />
        <Route path={path.FabricanteCadastrar} element={<FabricanteCadastrar />} />
        <Route path={path.FabricanteAtualizar} element={<FabricanteCadastrar />} />

        <Route path={path.Modelo} element={<Modelo />} />
        <Route path={path.ModeloCadastrar} element={<ModeloCadastrar />} />
        <Route path={path.ModeloAtualizar} element={<ModeloCadastrar />} />

        <Route path={path.UnidadeMedida} element={<UnidadeMedida />} />
        <Route path={path.UnidadeMedidaCadastrar} element={<UnidadeMedidaCadastrar />} />
        <Route path={path.UnidadeMedidaAtualizar} element={<UnidadeMedidaCadastrar />} />

        <Route path={path.FormaPagamento} element={<FormaPagamento />} />
        <Route path={path.FormaPagamentoCadastrar} element={<FormaPagamentoCadastrar />} />
        <Route path={path.FormaPagamentoAtualizar} element={<FormaPagamentoCadastrar />} />

        <Route path={path.Pedido} element={<PedidoPesquisar />} />
        <Route path={path.PedidoCadastrar} element={<PedidoDetalhes />} />
        <Route path={path.PedidoAtualizar} element={<PedidoDetalhes />} />

        <Route path={path.AdicionarProdutoCadastrar} element={<AdicionarProduto />} />
        <Route path={path.DevolucaoFornecedor} element={<DevolucaoFornecedor />} />
        <Route path={path.ImportacaoXML} element={<ImportacaoXML />} />
        <Route path={path.ImportacaoXMLCadastrar} element={<ImportacaoXMLCadastrar />} />

        <Route path={path.ContasReceber} element={<ContasReceber />} />
        <Route path={path.ContasReceberCadastrar} element={<ContasReceberCadastrar />} />
        <Route path={path.ContasReceberLancamento} element={<ContasReceberLancamento />} />

        <Route path={path.GrupoCliente} element={<GrupoCliente />} />
        <Route path={path.GrupoClienteCadastrar} element={<GrupoClienteCadastrar />} />
        <Route path={path.GrupoClienteAtulizar} element={<GrupoClienteCadastrar />} />

        <Route path={path.OrdemServico} element={<OrdemServico />} />
        <Route path={path.OrdemServicoCadastrar} element={<OrdemServicoCadastrar />} />
        <Route path={path.OrdemServicoAtualizar} element={<OrdemServicoCadastrar />} />
        <Route path={path.OrdemServicoCloning} element={<OrdemServicoCadastrar />} />

        <Route path={path.ContasPagar} element={<ContasPagar />} />
        <Route path={path.ContasPagarCadastrar} element={<ContasPagarCadastrar />} />
        <Route path={path.ContasPagarAtualizar} element={<ContasPagarCadastrar />} />


        <Route path={path.Cfop} element={<Cfop />} />
        <Route path={path.CfopCadastrar} element={<CfopCadastrar />} />
        <Route path={path.CfopAtualizar} element={<CfopCadastrar />} />

        <Route path={path.Maquina} element={<Maquina />} />
        <Route path={path.MaquinaCadastrar} element={<MaquinaCadastrar />} />
        <Route path={path.MaquinaAtualizar} element={<MaquinaCadastrar />} />
        <Route path={path.MaquinaConsultar} element={<MaquinaConsultar />} />

        <Route path={path.CaixaLancamento} element={<CaixaLancamento />} />

        <Route path={path.NotaFiscal} element={<NotaFiscal />} />

        <Route path={path.Boleto} element={<Boleto />} />

        <Route path={path.MovimentacaoEstoque} element={<MovimentacaoEstoque />} />

        <Route path={path.ReajusteEstoque} element={<ReajusteEstoque />} />
        <Route path={path.ReajusteEstoqueCadastrar} element={<ReajusteEstoqueCadastrar />} />

      </Route>
    </Routes>
  );
};

export default AppRoutes;
